import React, {useState} from "react";
import {Col, Container, Form, InputGroup, Row, Table} from "react-bootstrap";
import Header from "../Header/Header";
import NavBar from "../Header/NavBar";
import {useDispatch, useSelector} from "react-redux";
import {addBook, markUnavailableBooks, removeAllBooks, removeBook} from "../Store/book";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch} from "@fortawesome/free-solid-svg-icons";
import {format} from "date-fns";
import {getStockDetails} from "../Api/orderApi";
import {checkout} from "../Api/checkoutApi";
import {transaction} from "../Api/accountApi";

const NewOrder = () => {
    const dispatch = useDispatch();
    const [item, setItem] = useState({
        stockId: "",
        customerId: "",
        transactionType: "PURCHASE",
    });
    const [details, setDetails] = useState({
        customerId: item.customerId || "",
        transactionType: "",
        amount: "",
    });
    const [show, setShow] = useState(false);
    const book = useSelector((state) => state.Book.book);
    const [disabled, setDisabled] = useState(false);
    const [shippingRate, setShippingRate] = useState(0);
    const [reverseShippingRate, setReverseShippingRate] = useState(0);
    const [transactionList, setTransactionList] = useState([]);
    const [lastTransaction, setLastTransaction] = useState({})
    const [collectCashDisable, setCollectCashDisable] = useState(false);
    const [orderId, setOrderId] = useState("");

    const handleSubmit = async () => {
        const res = await getStockDetails({stockId: item.stockId})
        if (res.status === 200) {
            dispatch(
                addBook({
                    book: res.data.stockItem,
                    transactionType: item.transactionType,
                    title: res.data.bookTitle,
                })
            );
            if (item.transactionType === "LENDING") {
                setShow(true)
            }
            return;
        }
        if (res.status === 204) {
            alert("Stock Id not found.");
        }
    };
    const calculateTotals = () => {
        let buyingPrice = 0;
        let cautionDeposit = 0;

        book.forEach((item) => {
            if (item.transactionType === "PURCHASE") {
                buyingPrice += item.sellingPrice || 0;
            } else if (item.transactionType === "LENDING") {
                cautionDeposit += item.sellingPrice || 0;
            }
        });

        const shipping = shippingRate || 0;
        const reverseShipping = reverseShippingRate || 0;
        const total = buyingPrice + cautionDeposit + shipping + reverseShipping;

        return {
            buyingPrice,
            cautionDeposit,
            shipping,
            total,
        };
    };
    const {buyingPrice, cautionDeposit, shipping, total, reverseShipping} =
        calculateTotals();

    const handleCheckout = async () => {
        if (item.customerId === "") {
            alert("Please enter a customer id");
            return;
        }
        setDisabled(true)
        const body = book.map(({stockId, transactionType}) => ({
            stockId,
            transactionType,
        }));
        const res = await checkout({
            body,
            id: item.customerId,
            forwardShippingPrice: shippingRate,
            returnShippingPrice: reverseShippingRate
        })
        if (res.status === 200) {
            const {lastTransaction = {}, unavailableIsbnList = [], orderId} =
                await res.data;
            if (
                Array.isArray(unavailableIsbnList) &&
                unavailableIsbnList.length > 0
            ) {
                dispatch(markUnavailableBooks(unavailableIsbnList));
                setDisabled(false);
            } else {
                setLastTransaction(lastTransaction);
                setOrderId(orderId);
                alert("Checkout complete");
            }
        }
    };

    const handleTransaction = async () => {
        setCollectCashDisable(true);
        const response = await transaction({
            orderId,
            customerId: "+91" + item.customerId,
            method: "newOrder",
            setCollectCashDisable: setCollectCashDisable
        })
        if (response.status === 200) {
            setTransactionList(response.data);
            setShippingRate(0)
            setReverseShippingRate(0)
        }
    };

    const convertUnixTimestampToDate = (unixTimestamp) => {
        const date = new Date(unixTimestamp);
        return format(date, "yyyy-MM-dd hh:mm:ss a");
    };

    const calculateGrandTotal = (walletAmount, total) => {
        if (walletAmount > total) {
            return 0;
        } else {
            return total - walletAmount;
        }
    }
    const calculateRemainWalletAmount = (walletAmount, total) => {
        if (total > walletAmount) {
            return 0;
        } else {
            return walletAmount - total;
        }
    }
    const handleClear = () => {
        dispatch(removeAllBooks())
        setShippingRate(0)
        setReverseShippingRate(0)
        setDetails({
            customerId: item.customerId || "",
            transactionType: "",
            amount: "",
        })
        setShow(false)
        setItem({
            stockId: "",
            customerId: "",
            transactionType: "PURCHASE",
        })
        setDisabled(false)
        setCollectCashDisable(false)
        setOrderId("")
        setTransactionList([])
        setLastTransaction({})
    }
    return (
        <>
            <Header/>
            <div style={{marginTop: "40px"}}>
                <NavBar/>
            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    marginTop: "100px",
                    marginLeft: "100px",
                }}
            ></div>
            <Container>
                <Container>
                    <Form>
                        <Row>
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>StockId</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="number"
                                            placeholder="Enter stockId"
                                            required
                                            onChange={(e) => {
                                                setItem({...item, stockId: e.target.value});
                                            }}
                                        />
                                        <InputGroup.Text
                                            onClick={() => handleSubmit()}
                                            style={{cursor: "pointer"}}
                                        >
                                            <FontAwesomeIcon icon={faSearch}/>
                                        </InputGroup.Text>
                                    </InputGroup>
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>CustomerId</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter the customerId"
                                        required
                                        onChange={(e) =>
                                            setItem({...item, customerId: e.target.value})
                                        }
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Transactiom Type</Form.Label>
                                    <Form.Select
                                        onChange={(e) => {
                                            setItem({...item, transactionType: e.target.value});
                                        }}
                                        value={item.transactionType}
                                    >
                                        <option value="LENDING">LENDING</option>
                                        <option value="PURCHASE">PURCHASE</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Container>

                {book.length > 0 && (
                    <Container className="mt-4">
                        <h4 className="mb-3">Cart Items</h4>
                        <Table striped bordered hover responsive>
                            <thead>
                            <tr>
                                <th>Stock ID</th>
                                <th>Title</th>
                                <th>Transaction Type</th>
                                <th>Selling Price</th>
                                <th>Caution Deposit</th>
                                <th>Lending Price/Day</th>
                                <th>Remove</th>
                            </tr>
                            </thead>
                            <tbody>
                            {book.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        {item.stockId}
                                        {item.unavailable && (
                                            <span style={{color: "red", marginLeft: "5px"}}>
                                            (unavailable)
                                        </span>
                                        )}
                                    </td>
                                    <td>{item.title}</td>
                                    <td>{item.transactionType}</td>
                                    <td>
                                        {item.transactionType === "PURCHASE"
                                            ? `₹${item.sellingPrice}`
                                            : "--"}
                                    </td>
                                    <td>
                                        {item.transactionType === "LENDING"
                                            ? `₹${item.sellingPrice}`
                                            : "--"}
                                    </td>
                                    <td>
                                        {item.transactionType === "LENDING"
                                            ? `₹${item.lendingPricePerDay}`
                                            : "--"}
                                    </td>
                                    <td>
                                        <button
                                            onClick={() => dispatch(removeBook(item))}
                                            style={{
                                                background: "none",
                                                border: "none",
                                                color: "blue",
                                                fontSize: "18px",
                                                cursor: "pointer",
                                            }}
                                        >
                                            ✕
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </Container>
                )}


                <div style={{marginTop: "30px"}}>
                    <h5>Buying Price: ₹{buyingPrice}</h5>
                    <h5>Refundable Caution Deposit: ₹{cautionDeposit}</h5>
                    <h5>
                        Forward Shipping Price:{" "}
                        <input
                            type="number"
                            value={shippingRate}
                            onChange={(e) => setShippingRate(parseInt(e.target.value))}
                        />
                    </h5>
                    {show && (
                        <h5>
                            Reverse Shipping Price:{" "}
                            <input
                                type="number"
                                value={reverseShippingRate}
                                onChange={(e) => setReverseShippingRate(parseInt(e.target.value))}
                            />
                        </h5>
                    )}

                    <h5>Total: ₹{total}</h5>
                </div>
                <button
                    onClick={handleCheckout}
                    className="btn btn-primary"
                    style={{marginTop: "20px"}}
                    disabled={disabled || book.length === 0}
                >
                    Checkout
                </button>
            </Container>

            {Object.keys(lastTransaction).length > 0 && (
                <Container>
                    <div style={{marginTop: "30px"}}>
                        <h5>No.of.Book: {book.length}</h5>
                        <h5>Total:₹{total}</h5>
                        <h5>Wallet Balance:₹{lastTransaction.closingBalance}</h5>
                        <h5>Grand Total:₹{calculateGrandTotal(lastTransaction.closingBalance, total)}</h5>
                        <h5>Remaining Wallet
                            Balance:₹{calculateRemainWalletAmount(lastTransaction.closingBalance, total)}</h5>
                    </div>
                    <button onClick={handleTransaction}
                            className="btn btn-primary"
                            style={{marginTop: "20px"}}
                            disabled={collectCashDisable}
                    >
                        Collect Cash
                    </button>
                </Container>
            )}

            {transactionList.length > 0 && (
                <div className="container" style={{marginTop: "30px"}}>
                    <div className="d-flex justify-content-between align-items-center">
                        <h3 className="cart-page-title">
                            CustomerId:{item.customerId}
                        </h3>
                    </div>
                    <Table
                        striped
                        bordered
                        hover
                        responsive
                        className="transaction-table"
                    >
                        <thead>
                        <tr>
                            <th>Date</th>
                            <th>Order ID</th>
                            <th>Transaction Type</th>
                            <th>Amount</th>
                            <th>Hold</th>
                            <th>Open Balance</th>
                            <th>Close Balance</th>
                        </tr>
                        </thead>
                        <tbody>
                        {transactionList.map((transaction, index) => (
                            <tr key={index}>
                                <td>
                                    {convertUnixTimestampToDate(
                                        transaction.transactionTimeStamp
                                    )}
                                </td>
                                <td>{transaction.orderId}</td>
                                <td>{transaction.transactionType}</td>
                                <td>{`₹${transaction.amount}`}</td>
                                <td>{`₹${transaction.hold}`}</td>
                                <td>{`₹${transaction.openBalance}`}</td>
                                <td>{`₹${transaction.closingBalance}`}</td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>

                    <button onClick={() => handleClear()}
                            className="btn btn-primary"
                            style={{marginTop: "20px", marginBottom: "30px"}}>
                        Clear
                    </button>
                </div>
            )}
        </>
    );
};

export default NewOrder;
